import { Button, Box, Card, Stack, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { CustomeDialog, LoadingButton, ResetPassCode } from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import { useProfileSecurity } from "../hooks";

export const Security = ({ state: profileData }) => {
  const {
    state,
    email,
    isStoreAdmin,
    HandleChange,
    resetPassCode,
    closeResetPassword,
    handleInputChange,
    onSave2FA,
  } = useProfileSecurity({ profileData: profileData.profileDetails.data })

  const { is_two_factor_enabled, two_factor_method } = state.data

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 1,
        }}
      >
        <Card sx={{ p: "32px 24px", mb: "24px" }}>
          <Stack direction="row">
            <Stack width="100%">
              <Typography variant="subtitle1" fontWeight={600}>
                Change Password
              </Typography>
            </Stack>

            <Stack width="100%" alignItems="flex-end">
              <Button
                type="button"
                sx={{ width: 187, height: 41 }}
                variant="text"
                onClick={HandleChange}
              >
                Change password
              </Button>
            </Stack>
          </Stack>
        </Card>
        <Card sx={{ p: "32px 24px" }}>
          <Stack direction="row" gap="16px">
            <Stack>
              <Typography minWidth="220px" variant="subtitle1" fontWeight={600}>
                Two Factor Authentication
              </Typography>
            </Stack>

            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "16px",
                width: "100%",
              }}
            >
              <Stack width="100%" gap="16px">
                <InputControl
                  type="switch"
                  name="is_two_factor_enabled"
                  value={is_two_factor_enabled}
                  onChange={(e) => {
                    console.log(e.target.checked);

                    handleInputChange({
                      target: {
                        name: "is_two_factor_enabled",
                        value: e.target.checked ? 1 : 0,
                      },
                    });
                  }}
                />
                <Stack>
                  <RadioGroup
                    row
                    sx={{ gap: 2 }}
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="two_factor_method"
                    value={two_factor_method}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label="Email"
                      value="email"
                      onChange={(e) => handleInputChange(e)}
                    />
                    {/* <FormControlLabel
                      value="phone"
                      control={<Radio />}
                      label="Mobile"
                      onChange={(e) => handleInputChange(e)}
                    /> */}
                  </RadioGroup>
                </Stack>
              </Stack>
              <Button
                variant="contained"
                disabled={state.isSaveBtn}
                onClick={onSave2FA}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Box>
      {isStoreAdmin && (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 1,
          }}
        >
          <Card sx={{ p: "32px 24px", alignContent: "center" }}>
            <Stack direction="row">
              <Stack width="100%">
                <Typography variant="subtitle1" fontWeight={600}>
                  Pincode
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Typography
                  fontWeight={600}
                  fontSize="24px"
                  lineHeight="29px"
                  color="#808080"
                  sx={{ marginRight: "41px" }}
                >
                  {state.passCode !== ""
                    ? state.passCode
                    : profileData.profileDetails.data.pass_code}
                </Typography>
                <LoadingButton
                  type="button"
                  sx={{ width: 140, height: 35 }}
                  variant="text"
                  loading={state.isBusy}
                  onClick={resetPassCode}
                >
                  Reset Pincode
                </LoadingButton>
              </Stack>
            </Stack>
          </Card>
        </Box>
      )}
      <CustomeDialog
        open={state.isOpen}
        handleClose={closeResetPassword}
        size="md"
        PaperProps={{
          sx: {
            width: "423px",
            minHeight: "361px",
          },
        }}
        content={<ResetPassCode email={email} passCode={state.passCode} />}
      />
    </>
  );
};
